import "@babel/polyfill";
import domContentLoaded from "dom-content-loaded";
import $ from "jquery";
import "slick-carousel";

domContentLoaded(() => {
  // メインビジュアル - 西尾と63
  const $nishioSlider = $(".js-mv-nishio-slider, .js-mv-63-slider");
  $nishioSlider.slick({
    fade: true,
    arrows: false,
    speed: 1000,
    pauseOnHover: false,
    autoplay: true,
  });
  // メインビジュアル - 知立
  const $chiryuSlider = $(".js-mv-chiryu-slider, .js-sub-slider");
  const $bgSlider = $chiryuSlider.eq(0);
  const $ill = $(".js-ill");
  let ill = 1;

  $chiryuSlider.each((index, elm) => {
    const $slides = $(elm).find(".js-slide-img");
    const { length } = $slides;
    let current = 0;
    let next = 1;
    $slides.eq(current).addClass("current");
    if (index == 0) {
      $slides.eq(current).css({ transform: "scaleX(1)" });
    }
    setInterval(() => {
      const $current = $slides.eq(current);
      const $next = $slides.eq(next);
      if (index == 0) {
        // タイトルのイラストを動かす
        const sur = ill % 3;
        $ill.each((index, elm) => {
          if (sur == 0) {
            $(elm).css({ transform: "rotate(0)" });
          } else if (sur == 1) {
            $(elm).css({ transform: "rotate(-12deg)" });
          } else {
            $(elm).css({ transform: "rotate(12deg)" });
          }
        });
        ill += 1;
        // 背景のスライド
        $current.css({ transform: "scaleX(0)" });
        $current.one("transitionend", (event) => {
          $next.css({ transform: "scaleX(1)" });
          $current.removeClass("current");
          $next.addClass("current");
        });
      } else {
        // 背景以外のスライド
        $current.removeClass("current");
        $next.addClass("current");
      }
      if (next == length - 1) {
        next = 0;
        current += 1;
      } else if (current == length - 1) {
        next += 1;
        current = 0;
      } else {
        next += 1;
        current += 1;
      }
    }, 3000);
  });

  // インスタの表示用
  const instaUserId = $("#insta_list").data("user");
  const accessToken = $("#insta_list").data("token");
  $.ajax({
    // jQueryのajaxでjsonデータを取得します
    type: "GET",
    url: `https://graph.facebook.com/v17.0/${instaUserId}?access_token=${accessToken}&fields=name,media{caption,like_count,media_url,thumbnail_url,permalink,timestamp,username}`,
    dataType: "json",
    success(json) {
      const insta = json.media.data;
      for (let i = 0; i < 9; i++) {
        const url = insta[i].thumbnail_url || insta[i].media_url; // 画像の時はそのままで、動画の時はサムネイルを表示します
        const href = insta[i].permalink; // リンク先URLを取得

        $("#insta_list").append(`
						<div class="p-home-insta-item">
							<a class="p-home-insta-button" href="${href}" target="_blank" style="background-image: url(${url});"></a>
						</div>
					`);
      }
    },
  });
});
